<apcam-tooltip-custom
    [customMatTooltip]="'shared.languages.' + language | translate">
    <span
        matBadge="!"
        [matBadgeColor]="badgeColor"
        [matBadgeHidden]="!actionRequired">
        <apcam-flag
            [flagCode]="
                langCodeToIntlFEData.get(language)?.flagCode ?? ''
            "></apcam-flag>
    </span>
</apcam-tooltip-custom>
